import React from 'react';
import { Button, Chip, Rating, Stack, TextField } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { IRatingFormQuestion } from '../../Interfaces/IRatingForm';
import { MAX_SCALE_STEPS } from './ratingFormUtils';

/**
 * Mandanten-naher Vorschau-Block einer einzelnen Frage. Da der eigentliche
 * Bogen ueber OpenFormulare ausgeliefert wird, ist dies bewusst eine
 * vereinfachte Darstellung — sie soll dem fertigen Bogen nur aehneln, damit
 * man beim Bearbeiten sieht, was der Mandant am Ende vorfindet (#1009).
 */
export const QuestionPreview: React.FC<{ q: IRatingFormQuestion }> = ({
  q,
}) => {
  if (q.QuestionType === 'stars') {
    // Altdaten koennen ueber der Grenze liegen — Vorschau trotzdem deckeln.
    const raw = q.RangeMax && q.RangeMax > 0 ? q.RangeMax : 5;
    const max = Math.min(raw, MAX_SCALE_STEPS);
    return (
      <Rating
        readOnly
        value={0}
        max={max}
        emptyIcon={<StarBorderIcon fontSize='inherit' />}
      />
    );
  }
  if (q.QuestionType === 'scale') {
    // Skalen beginnen immer bei 1; Altdaten koennen darueber liegen, die
    // Vorschau zeigt trotzdem den kuenftigen Zustand.
    const min = 1;
    const max = Math.max(Math.min(q.RangeMax ?? 10, MAX_SCALE_STEPS), min);
    // Durch die Obergrenze passen jetzt immer alle Werte in eine Zeile —
    // die frueher noetige Abkuerzung mit "…" entfaellt.
    const values = Array.from({ length: max - min + 1 }, (_, i) => min + i);
    return (
      <Stack direction='row' spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
        {values.map(v => (
          <Chip key={v} size='small' variant='outlined' label={v} />
        ))}
      </Stack>
    );
  }
  if (q.QuestionType === 'yesno') {
    return (
      <Stack direction='row' spacing={1}>
        <Button size='small' variant='outlined' disabled>
          Ja
        </Button>
        <Button size='small' variant='outlined' disabled>
          Nein
        </Button>
      </Stack>
    );
  }
  return (
    <TextField
      size='small'
      fullWidth
      disabled
      multiline
      minRows={2}
      placeholder='Freitext-Antwort des Mandanten …'
    />
  );
};
